/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_mailbox",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "nonce",
                type: "uint64",
            },
        ],
        name: "BridgedToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint32",
                name: "hyperlaneDomain",
                type: "uint32",
            },
            {
                indexed: false,
                internalType: "uint32",
                name: "circleDomain",
                type: "uint32",
            },
        ],
        name: "DomainAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "HookSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_ism",
                type: "address",
            },
        ],
        name: "IsmSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "string",
                name: "symbol",
                type: "string",
            },
        ],
        name: "TokenAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "token",
                type: "address",
            },
            {
                indexed: true,
                internalType: "string",
                name: "symbol",
                type: "string",
            },
        ],
        name: "TokenRemoved",
        type: "event",
    },
    {
        inputs: [],
        name: "PACKAGE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_hyperlaneDomain",
                type: "uint32",
            },
            {
                internalType: "uint32",
                name: "_circleDomain",
                type: "uint32",
            },
        ],
        name: "addDomain",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "string",
                name: "_tokenSymbol",
                type: "string",
            },
        ],
        name: "addToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "circleMessageTransmitter",
        outputs: [
            {
                internalType: "contract ICircleMessageTransmitter",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "domains",
        outputs: [
            {
                internalType: "uint32[]",
                name: "",
                type: "uint32[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_router",
                type: "bytes32",
            },
        ],
        name: "enrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
            {
                internalType: "bytes32[]",
                name: "_addresses",
                type: "bytes32[]",
            },
        ],
        name: "enrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_origin",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "_sender",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "_message",
                type: "bytes",
            },
        ],
        name: "handle",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
    {
        inputs: [],
        name: "hook",
        outputs: [
            {
                internalType: "contract IPostDispatchHook",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        name: "hyperlaneDomainToCircleDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "_tokenMessenger",
                type: "address",
            },
            {
                internalType: "address",
                name: "_circleMessageTransmitter",
                type: "address",
            },
            {
                internalType: "address",
                name: "_liquidityLayerRouter",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "interchainSecurityModule",
        outputs: [
            {
                internalType: "contract IInterchainSecurityModule",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "liquidityLayerRouter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "localDomain",
        outputs: [
            {
                internalType: "uint32",
                name: "",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mailbox",
        outputs: [
            {
                internalType: "contract IMailbox",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_originDomain",
                type: "uint32",
            },
            {
                internalType: "address",
                name: "_recipient",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "_adapterData",
                type: "bytes",
            },
        ],
        name: "receiveTokens",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "string",
                name: "_tokenSymbol",
                type: "string",
            },
        ],
        name: "removeToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "routers",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_destinationDomain",
                type: "uint32",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "sendTokens",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_hook",
                type: "address",
            },
        ],
        name: "setHook",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_module",
                type: "address",
            },
        ],
        name: "setInterchainSecurityModule",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tokenAddressToSymbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "tokenMessenger",
        outputs: [
            {
                internalType: "contract ITokenMessenger",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        name: "tokenSymbolToAddress",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32",
                name: "_domain",
                type: "uint32",
            },
        ],
        name: "unenrollRemoteRouter",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint32[]",
                name: "_domains",
                type: "uint32[]",
            },
        ],
        name: "unenrollRemoteRouters",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class CircleBridgeAdapter__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(_mailbox, overrides) {
        return super.deploy(_mailbox, overrides || {});
    }
    getDeployTransaction(_mailbox, overrides) {
        return super.getDeployTransaction(_mailbox, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
//# sourceMappingURL=CircleBridgeAdapter__factory.js.map